import MessageModel from "model/Message.model";
import ProjectModel from "./Project.model";
import { Rating, SessionType } from "util/CommonConstant";
import IncidentInfoModel from "./IncidentInfo.model";
import { IContextFile } from "interface/common";
import { FILE_STATUS } from "util/Constant";
import SessionInfo from "./api/SessionInfo.model";

class ConversationModel {
  uuid: string | null;
  name: string | null;
  messages: MessageModel[];
  project: ProjectModel | null;
  followUps: string[];
  isLive?: boolean = false;
  createdTime?: Date = new Date();
  lastUpdated?: Date = new Date();
  sessionType?: SessionType;
  incidentInfo?: IncidentInfoModel;
  contextFiles: IContextFile[] = [];
  fileStatus: FILE_STATUS = FILE_STATUS.UNSPECIFIED;
  promptCycleIds: string[] = [];
  rating: Rating = Rating.RATING_UNSPECIFIED;
  ratingReason = "";
  sessionInfo?: SessionInfo;
  constructor(
    uuid: string | null = null,
    name: string | null = null,
    messages: MessageModel[] = [],
    project: ProjectModel | null = null,
    followUps: string[] = []
  ) {
    this.uuid = uuid;
    this.name = name;
    this.messages = messages;
    this.project = project;
    this.followUps = followUps;
  }
}

export default ConversationModel;
